<template>
	<div :class="['c-selection-popup', { active: active === true }]">
		<div
			:class="['checkbox-control', { selected: selectedNotes.length > 0 }]"
			@click="onToggleSelectionAll"
		>
			<span>
				<check-icon size="1x" class="custom-class"></check-icon>
			</span>
		</div>
		<a class="btn btn-primary btn-sm" href="#" @click="onCopy">
			Export {{ selectedNotes.length }}
			{{ noteText(selectedNotes.length) }}
			<span class="shortcut"> e </span>
		</a>
		<span class="divider"></span>
		<BucketSelect
			v-if="buckets.length > 0"
			size="sm"
			:bucketId="null"
			text="Move to bucket"
			@change="onBucketUpdate"
		>
		</BucketSelect>
		<span class="divider blank"></span>
		<FolderSelect
			v-if="folders.length > 0"
			size="sm"
			:folderId="null"
			text="Move to folder"
			@change="onFolderUpdate"
		>
		</FolderSelect>
		<span class="divider"></span>
		<a class="btn btn-sm ml-3" href="#" @click="onBulkDelete"> Delete </a>
		<span class="divider blank"></span>
		<a class="btn btn-sm ml-3" href="#" @click="onClear">
			Clear
			<span class="shortcut"> Esc </span>
		</a>
	</div>
</template>

<script>
import { XIcon, CheckIcon } from 'vue-feather-icons';
import FolderSelect from '@/components/ui/folder-select.vue';
import BucketSelect from '@/components/ui/bucket-select.vue';

export default {
	components: {
		BucketSelect,
		FolderSelect,
		XIcon,
		CheckIcon,
	},
	data: function () {
		var obj = {
			active: false,
			lock: false,
			key: '',
			errorMessage: '',
			options: {},
			previewText: '',
			previewHTML: '',
			copyText: 'Copy Text',
			copyHTML: 'Copy HTML',
			options: {
				removeLinks: false,
			},
		};
		return obj;
	},
	watch: {
		options: {
			deep: true,
			handler: function () {
				this.generatePreviewHTML();
				this.generatePreviewText();
			},
		},
		selectedNotes: function () {
			if (this.selectedNotes.length > 0) {
				this.$bvModal.show('modal-selection');
			} else {
				this.$bvModal.hide('modal-selection');
			}
		},
		selectionMode: function () {
			if (this.selectionMode) {
				this.active = true;
			} else {
				this.active = false;
			}
		},
	},
	computed: {
		buckets: function () {
			return this.$store.getters['bucket/buckets'];
		},
		folders: function () {
			return this.$store.getters['folder/folders'];
		},
		selectionMode: function () {
			if (this.selectedNotes.length > 0) {
				return true;
			} else {
				return false;
			}
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
		selectedNotes: function () {
			return this.$store.getters['note/selectedNotes'];
		},
		computedNotes: function () {
			let notes = this.notes;
			let selectedNotes = this.selectedNotes;
			let results = [];
			for (var i = 0; i < notes.length; i++) {
				if (selectedNotes.includes(notes[i].id)) {
					results.push(notes[i]);
				}
			}
			return results;
		},
		computedSites: function () {
			var grouped = _.groupBy(this.computedNotes, 'domain');
			var test = {};
			var keys = [];
			var count = 0;
			for (var property in grouped) {
				if (grouped.hasOwnProperty(property)) {
					test = _.groupBy(grouped[property], 'ref');
					keys = Object.keys(test);
					count = grouped[property].length;
					grouped[property] = {
						count: count,
						pages: test,
					};
				}
			}
			return grouped;
		},
	},
	methods: {
		noteText: function (len) {
			var str = 'Notes';
			if (len === 1) {
				str = 'Note';
			}
			return str;
		},
		onToggleSelectionAll: function () {
			this.$store.commit('note/CLEAR_SELECTION');
		},
		onFolderUpdate: function (folder) {
			if (folder) {
				let notes = this.notes;
				let selectedNotes = this.selectedNotes;
				let results = [];
				for (var i = 0; i < notes.length; i++) {
					if (selectedNotes.includes(notes[i].id)) {
						notes[i].folder = folder._id;
						results.push(notes[i]);
					}
				}
				this.$store.dispatch('note/bulkUpdateNotes', results);
			} else {
				let notes = this.notes;
				let selectedNotes = this.selectedNotes;
				let results = [];
				for (var i = 0; i < notes.length; i++) {
					if (selectedNotes.includes(notes[i].id)) {
						notes[i].folder = null;
						results.push(notes[i]);
					}
				}
				this.$store.dispatch('note/bulkUpdateNotes', results);
			}
		},
		onBucketUpdate: function (bucket) {
			if (bucket) {
				let notes = this.notes;
				let selectedNotes = this.selectedNotes;
				let results = [];
				for (var i = 0; i < notes.length; i++) {
					if (selectedNotes.includes(notes[i].id)) {
						notes[i].bucket = bucket._id;
						results.push(notes[i]);
					}
				}
				this.$store.dispatch('note/bulkUpdateNotes', results);
			} else {
				let notes = this.notes;
				let selectedNotes = this.selectedNotes;
				let results = [];
				for (var i = 0; i < notes.length; i++) {
					if (selectedNotes.includes(notes[i].id)) {
						notes[i].bucket = null;
						results.push(notes[i]);
					}
				}
				this.$store.dispatch('note/bulkUpdateNotes', results);
			}
		},
		onClear: function () {
			this.$store.commit('note/CLEAR_SELECTION');
		},
		onBulkDelete: function () {
			this.$bvModal.show('modal-delete');
		},
		onCopy: function () {
			this.$emit('copy');
			this.$bvModal.show('modal-copy');
		},
		isSelected: function (note) {
			if (this.selectedNotes.length < 1) {
				return false;
			}
			if (this.selectedNotes.includes(note.id)) {
				return true;
			} else {
				return false;
			}
		},
		onClose: function () {
			//this.$bvModal.hide("modal-selection");
		},
	},
	mounted: function () {
		//this.$root.$on("bv::modal::show", (bvEvent, modalId) => {});
	},
};
</script>

<style lang="scss">
.c-selection-popup {
	position: fixed;
	z-index: var(--z-4);
	bottom: 0;
	left: 50%;
	transition: transform 400ms cubic-bezier(0.19, 1, 0.22, 1);
	transform: translate(-50%, 100px);
	border-radius: var(--border-radius);
	background-color: var(--g3);
	width: fit-content;
	padding: var(--margin-lg);
	display: flex;
	justify-content: center;
	align-items: center;

	&:after {
		content: '';
		position: absolute;
		z-index: -1;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-radius: var(--border-radius);
		background: linear-gradient(
			0deg,
			rgba(255, 255, 255, 0.06) 0%,
			rgba(255, 255, 255, 0.11) 100%
		);
	}

	&.active {
		transform: translate(-50%, -10px);
	}

	.divider {
		display: inline-block;
		background-color: var(--g5);
		width: 1px;
		border-right: var(--g3) solid 1px;
		height: var(--spacer-sm);
		margin: 0 var(--margin-lg);

		&.blank {
			width: 0;
			border: none;
			background-color: transparent;
			margin: 0 var(--margin);
		}
	}

	.checkbox-control {
		display: inline-block;
		width: 35px;
		height: 30px;
		cursor: pointer;
		user-select: none;
		position: relative;

		> span {
			display: block;
			position: absolute;
			top: 4px;
			//bottom: calc(50% - 10px);
			left: 4px;
			width: 20px;
			height: 20px;
			border-radius: 3px;
			background-color: var(--p5);
			border: var(--p4) solid 2px;
			transition: all 60ms linear;

			svg {
				display: block;
				stroke: var(--p5);
				stroke-width: 4px;
			}
		}

		&.first {
			&:after {
				top: auto;
				bottom: 0;
				height: 50%;
			}
		}

		&.last {
			&:after {
				height: 50%;
			}
			&.first {
				&:after {
					content: none;
				}
			}
		}

		&:hover {
			> span {
				background-color: var(--p4);
				border-color: var(--p4);
				svg {
					stroke: var(--p5);
				}
			}
		}
		&.selected {
			> span {
				background-color: var(--p3);
				border-color: var(--p3);
				svg {
					stroke: var(--p5);
				}
			}
		}
	}

	@include media-breakpoint-down(xs) {
		flex-direction: column;
		align-items: flex-start;
		left: auto;
		right: 10px;
		transform: translate(0, 200px);

		.btn,
		.btn-group,
		.c-folder-select,
		.c-bucket-select {
			width: 100%;
		}
		.divider {
			height: var(--margin);
		}

		&.active {
			transform: translate(0, -10px);
		}
	}
}
</style>
